<template>
    <div class="APagination flex between w-100"
         ref="paginationRef"
    >
        <pagination
            v-model="page"
            :records="records"
            :options="options"
            :per-page="perPage"
            @paginate="onPaginate"
            class="v-pagination"
        />
        <ABtn
            v-if="showMore && page < records&&options.nextPage!=''"
            class="outlined flat"
            color="#000"
            :label="messages.moreBtn"
            @click="onShowMore"
        />
    </div>
</template>

<script>
import {ref, inject, computed} from 'vue';
import Pagination from 'v-pagination-3';
import {ABtn} from "./ABtn";

export default {
    name: "APagination",
    props: {
        currentPage: {
          type: Number,
          default: 1
        },
        perPage: {
            type: Number,
            default: 5
        },
        totalPages: {
            type: Number,
        },
        records: {
            type: Number,
            default: 500
        },
        showMore: {
            type: Boolean,
            default: false
        },
        messages: Object,
        options: {
            type: Object,
            default: () => ({
                chunk: 5,
                edgeNavigation: false,
                hideCount: true,
                texts: {}
            })
        }
    },
    components: {
        Pagination,
        ABtn
    },
    setup(props, ctx) {
      const translates = inject('translates', {})
      const paginationRef = ref(null)
      const page = ref(props.currentPage);

        const onShowMore = () => {
            const nextPage = props.currentPage + 1
            //console.log(props.currentPage);

            const nextPageBtn = getElementByTextValue(paginationRef.value.querySelectorAll('button.page-link'), nextPage)
            if(nextPageBtn) nextPageBtn.classList.add('active');
            ctx.emit('showMore', props.options.nextPage)
        }

        const onPaginate = (val) => {
            console.log(props);
          if(props.options.linkTemplate!==undefined) {
            location.href = props.options.linkTemplate.replace('#PAGE#', val);
          } else {
              ctx.emit('input', val)
          }
        }


        function getElementByTextValue(targetElements, value) {
            let element = null
            for (const el of targetElements) {
                if (el.textContent && el.textContent.trim().includes(value)) {
                    element = el
                }
            }
            return element
        }


        return {
            page,
            onPaginate,
            translates,
            onShowMore,
            paginationRef
        }
    }
}
</script>

<style scoped lang="scss">
@import "ABtn/css/ABtn";

%btn {
    @extend .a-btn;
    background: transparent;
    color: var(--c-gray-100);
    border: 1px solid var(--c-gray-600);
    transition: background .3s;
    height: 50px;
    min-width: 50px;
    justify-content: center;
    align-items: center;
    border-radius: 6px;

    &:hover {
        background: var(--c-gray-600);
    }

    &.active {
        border-color: var(--c-primary-200);
    }
}

::v-deep .a-btn {
    @extend %btn;
    border: 1px solid var(--c-gray-600) !important;
    opacity: 1 !important;

    &::before {
        opacity: 0 !important;
    }

    &::after {
        border: unset !important;
    }
}

::v-deep .VuePagination {
    @include tablet {
        overflow: auto;
    }

    &__count {
        //display: none;
    }

    &__pagination {
        display: flex;
        gap: 10px;
      justify-content: space-between;

    }

    li {
        list-style: none;
      &.disabled {
        opacity: 0.5;
      }
    }

    button {
        @extend %btn;
        @include mobile {
          height: 35px;
          min-width: 35px;
          padding: 7px;

        }
        &.active {
            background: var(--c-gray-600);
        }
    }
}

.APagination {
    width: 100%;
    padding: 25px 0;

    @include tablet {
        flex-direction: column;
        gap: 25px;
    }
  .v-pagination {

  }
}
</style>